<template>
  <div class="row">
    <div class="col-lg-12">
      <h2 class="page-header">Edital</h2>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Lista de editais"
            api-url="edital/listar"
            report-title="Editais"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'concursosEdital'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="col-sm-4">
                <label class="custom-font">Nº Edital</label>
                <input
                  type="text"
                  v-model="numero"
                  class="form-control"
                  name="numero_filter"
                />
              </div>
              <div class="col-sm-4">
                <label class="custom-font">Nº Processo</label>
                <input
                  type="text"
                  v-model="processo_numero"
                  class="form-control"
                  name="processo_numero_filter"
                />
              </div>
              <div class="col-sm-2">
                <label class="custom-font">Publicado</label>
                <div class="custom-select">
                  <select
                    name="publicado_filter"
                    v-model="publicado"
                    @change="consultar"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12">
                <button
                  @click="consultar()"
                  class="btn btn-default margem-topo"
                  name="btnFiltrar"
                >
                  <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                  Filtrar
                </button>
                <button
                  @click="limpar()"
                  class="btn btn-default margem-topo"
                  name="btnLimpar"
                >
                  <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                  Limpar Filtros
                </button>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'salvar_edital' }"
              >
                <font-awesome-icon :icon="'plus'" /> Adicionar
              </router-link>
            </template>
            <template slot="rowrender" slot-scope="props">
              <button
                title="Editar dados do Edital"
                type="button"
                class="btn btn-success"
                @click="editar(props.rowData)"
              >
                <font-awesome-icon :icon="'edit'" />
              </button>
              <router-link
                title="Importar Habilitados"
                class="btn btn-success"
                :to="{
                  name: 'habilitados',
                  params: { edital: props.rowData }
                }"
              >
                <font-awesome-icon :icon="'users'" />
              </router-link>
              <router-link
                title="Importar Pré-Habilitados"
                class="btn btn-success"
                :to="{
                  name: 'pre_habilitados',
                  params: { edital: props.rowData }
                }"
              >
                <font-awesome-icon :icon="'upload'" />
              </router-link>
              <router-link
                title="Nomear Candidatos"
                class="btn btn-success"
                :to="{
                  name: 'nomeados',
                  params: { edital: props.rowData }
                }"
              >
                <font-awesome-icon :icon="'list'" />
              </router-link>
              <a
                title="Exportar edital e seus arquivos anexados"
                class="btn btn-success"
                target="_blank"
                :href="exportarEditalComArquivosAnexadosCSV(props.rowData)"
              >
                <font-awesome-icon :icon="'file-csv'" />
              </a>
              <button
                title="Excluir edital"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash'" />
              </button>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  name: 'editais',
  data() {
    return {
      fields: [
        {
          name: 'numero',
          title: 'Nº Edital',
          filterable: true
        },
        {
          name: 'processo_numero',
          title: 'Nº Processo',
          sortField: 'processo_numero',
          filterable: true
        },
        {
          name: 'publicado',
          title: 'Publicado',
          sortField: 'publicado',
          filterable: true,
          callback(value) {
            return value ? 'Sim' : 'Não'
          },
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'cargos_descricao',
          title: 'Cargos',
          callback(value) {
            let cargos = value[0]
            for (let index = 1; index < value.length; index++) {
              cargos += `, ${value[index]}`
            }
            return cargos
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center col-xs-3'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'salvar_edital',
        params: data
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`edital/${data.id}`)
            .then(response => {
              this.$toastr.s('Edital excluído com sucesso')
              dt.refresh()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao excluir o edital, tente novamente e, se persistir o erro, entre em contato com o administrador.'
              )
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este edital? Todos os dados anexados a ele (cargos e habilitados) também serão excluídos.',
        config
      )
    },
    // exportarEditalComArquivosAnexadosCSV(data) {
    //   var url = this.$root.$data.apiUrl + `exportareditalarquivosanexadoscsv/${data.id}`
    //   return url
    // },
    exportarEditalComArquivosAnexadosCSV(data) {
      const { token } = JSON.parse(localStorage.getItem('daUser'))
      var url =
        this.$root.$data.apiUrl +
        `exportareditalarquivosanexadoscsv/${data.id}?token=${token}`
      return url
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      /**
       * Se não fizer desse jeito, um a um, não vai.
       * Passando um objeto completo, dá pau. Precisa limpar 2 vezes.
       * Full bugado.
       */
      this.numero = ''
      this.processo_numero = ''
      this.publicado = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'concursosEdital',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { numero, processo_numero, publicado } = this
      return {
        numero,
        processo_numero,
        publicado
      }
    },
    pagina: {
      get() {
        const { concursosEdital } = this.$store.state.vuetableState
        const { pagina } = concursosEdital
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'concursosEdital',
          value: value
        })
      }
    },
    numero: {
      get() {
        const { concursosEdital } = this.$store.state.vuetableState
        const { numero } = concursosEdital.filtros

        return numero
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'concursosEdital',
          value: value
        })
        this.resetPageStore()
      }
    },
    processo_numero: {
      get() {
        const { concursosEdital } = this.$store.state.vuetableState
        const { processo_numero } = concursosEdital.filtros

        return processo_numero
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processo_numero',
          collection: 'concursosEdital',
          value: value
        })
        this.resetPageStore()
      }
    },
    publicado: {
      get() {
        const { concursosEdital } = this.$store.state.vuetableState
        const { publicado } = concursosEdital.filtros

        return publicado
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'publicado',
          collection: 'concursosEdital',
          value: value
        })
        this.resetPageStore()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/index.vue